import {
  CustomMissingTranslationHandler,
  dynamicLocaleFactory,
  httpLoaderFactory,
} from '$core/helpers/ngx-translate';
import { LanguageService } from '$core/services/language.service';
import { environment } from '$env/environment';
import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeBe from '@angular/common/locales/be';
import localeEn from '@angular/common/locales/en';
import localeRu from '@angular/common/locales/ru';
import { LOCALE_ID, NgModule } from '@angular/core';
import { DayjsConfigService } from '$core/services/dayjs-config.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
} from '@ngx-translate/core';
import { TreeModule } from '@ali-hm/angular-tree-component';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

registerLocaleData(localeRu, 'ru');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeBe, 'by');

environment.saveTokenCookie = false;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    HttpClientModule,
    BrowserAnimationsModule,
    TreeModule,
    TranslateModule.forRoot({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CustomMissingTranslationHandler,
      },
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient],
      },
      useDefaultLang: true,
    }),
    GoogleTagManagerModule.forRoot({
      id: environment.gtag ? (<any>environment.gtag).site : null,
    }),
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: dynamicLocaleFactory,
      deps: [LanguageService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private dayjsConfig: DayjsConfigService) {}
}
